import styled, { css } from 'styled-components/macro';
import { colorAccentAlert100, colorAccentAlert900, colorAccentError100, colorAccentError700, colorAccentError900, colorAccentInfo100, colorAccentInfo900Base, colorAccentSuccess100, colorAccentSuccess700Base, colorAccentSuccess800, colorBlackTransparent50, colorCoreBlack900Base, } from '@yme/tokens/colors';
import { CORNER_RADIUS } from '@yme/tokens/cornerRadius';
import { INDENT } from '@yme/tokens/sizes';
import { getTextStyles } from '@yme/utils/styles';
import { AlertType } from './types';
export const AlertStyled = styled.div `
  display: flex;
  flex-wrap: wrap;
  justify-content: ${({ alignCenter }) => (alignCenter ? 'center' : 'space-between')};
  align-items: ${({ flexAlign }) => flexAlign || 'center'};
  row-gap: 12px;

  ${({ isRightToLeft }) => isRightToLeft && 'direction: rtl;'};
  ${({ isFullWidth }) => isFullWidth && 'flex-basis: 100%;'};

  border-radius: ${CORNER_RADIUS.s};
  padding: 8px 10px;

  border: 1px solid ${colorCoreBlack900Base};
  background-color: ${colorBlackTransparent50};
  color: ${colorCoreBlack900Base};

  svg {
    path {
      fill: ${colorCoreBlack900Base};
    }
  }

  ${getTextStyles('Ubuntu', 400, 14, 20)};

  ${({ type }) => type === AlertType.ERROR &&
    css `
      border-color: ${colorAccentError700};
      background-color: ${colorAccentError100};
      color: ${colorAccentError900};

      svg {
        path {
          fill: ${colorAccentError900};
        }
      }
    `}

  ${({ type }) => type === AlertType.SUCCESS &&
    css `
      border-color: ${colorAccentSuccess700Base};
      background-color: ${colorAccentSuccess100};
      color: ${colorAccentSuccess800};

      svg {
        path {
          fill: ${colorAccentSuccess800};
        }
      }
    `}

  ${({ type }) => type === AlertType.INFO &&
    css `
      border-color: ${colorAccentInfo900Base};
      background-color: ${colorAccentInfo100};
      color: ${colorAccentInfo900Base};

      svg {
        path {
          fill: ${colorAccentInfo900Base};
        }
      }
    `}

  ${({ type }) => type === AlertType.WARNING &&
    css `
      border-color: ${colorAccentAlert900};
      background-color: ${colorAccentAlert100};
      color: ${colorAccentAlert900};

      svg {
        path {
          fill: ${colorAccentAlert900};
        }
      }
    `}
`;
export const AlertMessageExtra = styled.div `
  display: flex;
  flex-grow: 1;
  flex-direction: row;
  justify-content: flex-end;
`;
export const AlertMessageExtraContent = styled.div `
  display: flex;
  column-gap: 6px;
`;
export const AlertMessageWrapper = styled.div `
  display: flex;
  flex: 1 1 ${({ isFullWidth }) => (isFullWidth ? '100%' : '80%')};
  gap: 6px;
  overflow: hidden;

  ${({ alignCenter }) => alignCenter && 'justify-content: center;'};
`;
export const AlertMessageText = styled.span ``;
export const AlertActions = styled.div `
  display: flex;
  gap: ${INDENT.xxs};

  ${({ isRightToLeft }) => isRightToLeft ? `margin-right: ${INDENT.xxxs};` : `margin-left: ${INDENT.xxxs};`};
`;
